module.exports = __webpack_public_path__ + "static/media/viu.286feb3d.svg";